module.exports = __webpack_public_path__ + "static/Tnohito1-ae95ed7d1953d9f80112790864674539.png";